import React, {ReactNode} from 'react';
import {Colors} from "@Styles/Colors.style";

interface ColorGradedNodeProps {
    rating: string | number,
    className?: string,
    children: ReactNode,
}

/**
 * No longer changing color based on rating. Rename or remove this component.
 * @param props
 * @constructor
 */
function ColorGradedNode(props: ColorGradedNodeProps) {
    const {
        rating,
        children,
        className = "gb--label gb--review-ratings review-rating",
    } = props

    const style = {backgroundColor: Colors.secondaryColor}
    return (
        <span className={className} style={style}>
            {children}
        </span>
    );
}

export default ColorGradedNode;